import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/login/quick-register')({
  beforeLoad: () => {
    throw redirect({
      to: '/login/',
      search: {
        state: 'quick',
        redirect: '/',
      },
    });
  },
  component: () => {
    return null;
  },
});
